import styled from '@emotion/styled';

import { useI18n } from '../../../hooks/useI18nFormatters.tsx';
import { useApi } from '../../../store/SelectedHomeyStore.js';

import { theme } from '../../../theme/theme.ts';
import { su } from '../../../theme/functions/su.js';

import { Dialog } from '../../../components/overlay/Dialog.jsx';
import { SolidButton } from '../../../components/buttons/SolidButton.tsx';
import { IconButton } from '../../../components/buttons/IconButton.tsx';
import { Icon } from '../../../components/common/Icon.tsx';
import { RoundIconWrapper } from '../../../components/common/Icon.tsx';

import { iconCloseThin } from '../../../theme/icons/interface/close-thin/index.js';
import { iconLock } from '../../../theme/icons-v2/core/lock.js';

export function FamilySettingsDialogLocalUserUnsupported(props) {
  const { i18n } = useI18n();
  const { api } = useApi();

  function handleClosePress() {
    props.onCloseRequest();
  }

  return (
    <Dialog
      containFocus={true}
      // autoFocus={true}
      onClose={() => {
        props.onCloseRequest();
      }}
    >
      <S.Root>
        <S.CloseIconButtonWrapper>
          <IconButton
            url={iconCloseThin}
            color={theme.color.icon_light}
            size={theme.icon.size_small}
            onPress={handleClosePress}
          />
        </S.CloseIconButtonWrapper>

        <RoundIconWrapper size="80px" color={theme.color.blue_o_05}>
          <Icon size="32px" url={iconLock} color={theme.color.blue} />
        </RoundIconWrapper>

        <S.Title>
          {i18n.messageFormatter('settings.system.usersLocalUserUnsupportedDialogTitle')}
        </S.Title>

        <S.Info>
          {i18n.messageFormatter('settings.system.usersLocalUserUnsupportedDialogSubtitle', {
            address: (
              <a
                key="link"
                href={`https://my.homey.app/homeys/${api?.homey.id}/settings/system/family`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: theme.color.orange, textDecoration: 'none' }}
              >
                {`https://my.homey.app/settings/system/family`}
              </a>
            ),
          })}
        </S.Info>

        <S.Actions>
          <SolidButton
            autoFocus={true}
            styleFlat={true}
            styleColor="blue"
            onPress={handleClosePress}
          >
            {i18n.messageFormatter('common.continue')}
          </SolidButton>
        </S.Actions>
      </S.Root>
    </Dialog>
  );
}

function S() {}
FamilySettingsDialogLocalUserUnsupported.S = S;

S.Root = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  width: 360px;
  padding: ${su(4)} ${su(2)} ${su(2)};
`;

S.CloseIconButtonWrapper = styled.div`
  position: absolute;
  right: ${su(2)};
  top: ${su(2)};
`;

S.Title = styled.h3`
  text-align: center;
  padding-top: ${su(2)};
`;

S.Info = styled.p`
  color: ${theme.color.text_light};
  text-align: center;
`;

S.Actions = styled.div`
  display: grid;
  width: 100%;
  grid-auto-flow: column;
  grid-gap: ${su(1)};
`;
